<template>
    <XyzTransition appear xyz="fade">
        <div
            class="bg-white rounded-lg shadow-md p-5 m-2 lg:mx-4 lg:w-1/2 sticky top-20"
        >
            <div class="flex justify-between items-start h-14">
                <div class="font-medium text-gray-600 text-xl">Paquetes</div>
                <Button @click="openDialog">
                    <Icon size="14"><Plus /></Icon>
                </Button>
            </div>
            <DataTable
                :value="products"
                dataKey="id"
                responsiveLayout="scroll"
                scrollHeight="400px"
            >
                <template #empty>
                    <div class="text-gray-600">
                        Haz click en (+) para agregar un paquete.
                    </div>
                </template>
                <Column header="Cant.">
                    <template #body="slotProps">
                        <div class="text-sm">
                            {{ slotProps.data.cantidad }}
                        </div>
                    </template>
                </Column>
                <Column header="Desc.">
                    <template #body="slotProps">
                        <div class="text-sm">
                            {{ slotProps.data.descripcion }}
                        </div>
                    </template>
                </Column>
                <Column header="Peso">
                    <template #body="slotProps">
                        <div class="text-sm">{{ slotProps.data.peso }}kg</div>
                    </template>
                </Column>
                <Column header="Dimen.">
                    <template #body="slotProps">
                        <div class="text-sm flex flex-col">
                            <span> Alto: {{ slotProps.data.alto }}cm</span>
                            <span> Largo: {{ slotProps.data.largo }}cm</span>
                            <span> Ancho: {{ slotProps.data.ancho }}cm</span>
                        </div>
                    </template>
                </Column>
                <Column>
                    <template #body="slotProps">
                        <div class="flex flex-col space-y-2">
                            <a
                                class="text-[10px] hover:underline hover:cursor-pointer text-gray-500"
                                @click="editProduct(slotProps.data)"
                            >
                                <div class="flex space-x-1 items-center">
                                    <Icon size="10">
                                        <Edit />
                                    </Icon>
                                    <span> Editar </span>
                                </div>
                            </a>
                            <a
                                class="text-[10px] hover:underline hover:cursor-pointer text-gray-500"
                                @click="deleteProduct(slotProps.data.id)"
                            >
                                <div class="flex space-x-1 items-center">
                                    <Icon size="10">
                                        <Trash />
                                    </Icon>
                                    <span> Eliminar </span>
                                </div>
                            </a>
                        </div>
                    </template>
                </Column>
            </DataTable>
        </div>
    </XyzTransition>
    <Dialog
        v-model:visible="productFormDialog"
        :closeOnEscape="true"
        :closable="false"
        :modal="true"
        id="overlay_panel"
        style="max-width: 450px"
        :breakpoints="{ '960px': '75vw' }"
    >
        <template #header>
            <div class="font-medium text-gray-700 text-xl">
                {{ isEdit ? "Editar" : "Agregar" }} producto
            </div>
        </template>
        <div class="flex flex-col space-y-2 p-2">
            <div class="flex flex-col">
                <div class="my-1 text-sm text-gray-700">Categorias</div>
                <Dropdown
                    v-model="selectedCategory"
                    :options="categories"
                    optionLabel="nombre"
                    optionValue="id"
                    :filter="true"
                    placeholder="Seleccionar categoria"
                    emptyMessage="Sin categorias regitradas"
                    :showClear="true"
                    class="h-[42px] flex items-center"
                    @change="setCategory"
                >
                </Dropdown>
            </div>
            <div class="flex flex-col">
                <label for="descripcion" class="text-sm my-1 text-gray-700">
                    Descripción<span class="text-red-400">*</span>
                </label>
                <input
                    id="descripcion"
                    v-model="product.descripcion"
                    type="text"
                    class="t-input"
                    placeholder="Detalles de producto"
                />
                <small
                    v-if="errors?.descripcion"
                    id="destino_nombre-help"
                    class="p-error"
                >
                    {{ errors?.descripcion[0] }}
                </small>
            </div>
            <div class="flex flex-col">
                <label for="peso" class="text-sm my-1 text-gray-700"
                    >Peso<span class="text-red-400">*</span>
                </label>
                <input
                    id="peso"
                    v-model="product.peso"
                    type="number"
                    class="t-input"
                    placeholder="kg"
                    min="0.1"
                    max="100"
                    step="0.1"
                />
                <small v-if="errors?.peso" id="peso-help" class="p-error">
                    {{ errors?.peso[0] }}
                </small>
            </div>
            <div class="flex space-x-2">
                <div class="flex flex-col w-1/3">
                    <label for="alto" class="text-sm my-1 text-gray-700"
                        >Alto<span class="text-red-400">*</span>
                    </label>
                    <input
                        id="alto"
                        v-model="product.alto"
                        type="number"
                        class="t-input"
                        placeholder="cm"
                        min="1"
                        max="1000"
                    />
                </div>
                <div class="flex flex-col w-1/3">
                    <label for="largo" class="text-sm my-1 text-gray-700">
                        Largo<span class="text-red-400">*</span>
                    </label>
                    <input
                        id="largo"
                        v-model="product.largo"
                        type="number"
                        class="t-input"
                        placeholder="cm"
                        min="1"
                        max="1000"
                    />
                </div>
                <div class="flex flex-col w-1/3">
                    <label for="ancho" class="text-sm my-1 text-gray-700"
                        >Ancho<span class="text-red-400">*</span></label
                    >
                    <input
                        id="ancho"
                        v-model="product.ancho"
                        type="number"
                        class="t-input"
                        placeholder="cm"
                        min="1"
                        max="1000"
                    />
                </div>
            </div>
            <div class="flex flex-col">
                <small v-if="errors?.alto" id="alto-help" class="p-error">
                    {{ errors?.alto[0] }}
                </small>
                <small v-if="errors?.largo" id="largo-help" class="p-error">
                    {{ errors?.largo[0] }}
                </small>
                <small v-if="errors?.ancho" id="ancho-help" class="p-error">
                    {{ errors?.ancho[0] }}
                </small>
            </div>
            <div class="flex space-x-2">
                <div class="flex flex-col w-1/2">
                    <label for="cantidad" class="text-sm my-1 text-gray-700"
                        >Cantidad<span class="text-red-400">*</span></label
                    >
                    <input
                        id="cantidad"
                        v-model="product.cantidad"
                        type="number"
                        class="t-input"
                        min="1"
                    />
                    <small
                        v-if="errors?.cantidad"
                        id="cantidad-help"
                        class="p-error"
                    >
                        {{ errors?.cantidad[0] }}
                    </small>
                </div>
                <div class="flex flex-col w-1/2">
                    <label for="precio" class="text-sm my-1 text-gray-700"
                        >Precio detallado
                    </label>
                    <input
                        id="precio"
                        v-model="product.precio"
                        type="number"
                        class="t-input"
                        placeholder="$0.00"
                    />
                    <small
                        v-if="errors?.precio"
                        id="precio-help"
                        class="p-error"
                    >
                        {{ errors?.precio[0] }}
                    </small>
                </div>
            </div>
            <div v-if="$page.props.user.tipo === 'sucursal_admin'">
                <div v-if="showAddToCategories">
                    <div class="flex items-center mb-4 mt-2">
                        <input
                            id="add_to_category"
                            aria-describedby="multiple_etiqueta"
                            type="checkbox"
                            class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                            v-model="addNewToCat"
                        />
                        <label
                            for="add_to_category"
                            class="ml-3 text-sm text-gray-700"
                            >Agregar a categorias
                        </label>
                    </div>
                </div>

                <div v-if="showUpdateCatategory">
                    <div class="flex items-center mb-4 mt-2">
                        <input
                            id="update_category"
                            aria-describedby="multiple_etiqueta"
                            type="checkbox"
                            class="w-4 h-4 text-primary-600 bg-gray-100 rounded border-gray-300 focus:ring-primary-500 focus:ring-2"
                            v-model="updateCat"
                        />
                        <label
                            for="update_category"
                            class="ml-3 text-sm text-gray-700"
                            >Guardar cambios
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div class="flex justify-end">
                <Button variant="dismissive" @click="closeDialog"
                    >Cancelar</Button
                >
                <template v-if="isEdit">
                    <Button :loading="isLoading" @click="updateProduct">
                        Editar
                    </Button>
                </template>
                <template v-else>
                    <Button :loading="isLoading" @click="addProduct">
                        Agregar
                    </Button>
                </template>
            </div>
        </template>
    </Dialog>
</template>

<script>
import { Icon } from "@vicons/utils";
import { Plus, Trash, Edit } from "@vicons/fa";
import Button from "@/shared/Button.vue";
import Spinner from "@/shared/Spinner.vue";
import axios from "axios";

export default {
    name: "PaquetesForm",
    components: {
        Button,
        Spinner,
        Icon,
        Plus,
        Trash,
        Edit,
    },
    props: {
        categorias: Array,
    },
    data() {
        return {
            productFormDialog: false,
            isLoading: false,
            isEdit: false,
            errors: null,
            showAddToCategories: true,
            addNewToCat: false,
            showUpdateCatategory: false,
            updateCat: false,
            categories: [],
            product: {
                descripcion: null,
                peso: null,
                alto: null,
                largo: null,
                ancho: null,
                cantidad: 1,
                precio: null,
            },
            products: [],
            selectedCategory: null,
        };
    },
    emits: ["updatePaquetes"],
    mounted() {
        this.categories = this.categorias;
    },
    methods: {
        openDialog() {
            this.productFormDialog = true;
        },
        closeDialog() {
            this.productFormDialog = false;
            this.isEdit = false;
            this.clearErrors();
            this.clearProductForm();
        },
        setErrors(errors) {
            this.errors = errors;
        },
        clearErrors() {
            this.errors = null;
        },
        clearProductForm() {
            this.showAddToCategories = true;
            this.addNewToCat = false;
            this.showUpdateCatategory = false;
            this.updateCat = false;
            this.selectedCategory = null;
            this.product = {
                observacion: null,
                peso: null,
                alto: null,
                largo: null,
                ancho: null,
                cantidad: 1,
                precio: null,
            };
        },
        addNewToCategories() {
            axios
                .post("/categorias/crear-categoria", { ...this.product })
                .then((res) => {
                    this.$toast.add({
                        severity: "success",
                        summary: res.data.message,
                        life: 5000,
                    });
                    this.fetchCategories();
                });
        },

        updateCategory() {
            axios
                .post("/categorias/actualizar-categoria/" + this.product.id, {
                    ...this.product,
                })
                .then((res) => {
                    this.$toast.add({
                        severity: "success",
                        summary: res.data.message,
                        life: 5000,
                    });
                    this.fetchCategories();
                });
        },
        addProduct() {
            this.isLoading = true;
            axios
                .post("validar-paquete", this.product)
                .then((res) => {
                    if (res.data.valido) {
                        this.isLoading = false;
                        this.products.push({
                            id: new Date(),
                            ...this.product,
                        });
                        this.$emit("updatePaquetes", this.products);
                        if (this.addNewToCat) {
                            this.addNewToCategories();
                        }
                        if (this.updateCat) {
                            this.updateCategory();
                        }
                        this.clearErrors();
                        this.closeDialog();
                    }
                })
                .catch((err) => {
                    this.setErrors(err.response.data.errors);
                    this.isLoading = false;
                });
        },
        editProduct(product) {
            this.isEdit = true;
            this.product = { ...product };
            this.openDialog();
        },
        updateProduct() {
            this.isLoading = true;
            let productToUpdate = this.product;
            axios
                .post("validar-paquete", this.product)
                .then((res) => {
                    if (res.data.valido) {
                        this.isLoading = false;

                        this.products = this.products.map((p) =>
                            p.id === this.product.id ? this.product : p
                        );

                        this.$emit("updatePaquetes", this.products);
                        this.clearErrors();
                        this.closeDialog();
                    }
                })
                .catch((err) => {
                    this.setErrors(err.response.data.errors);
                    this.isLoading = false;
                });
        },
        deleteProduct(id) {
            this.products = this.products.filter((p) => p.id !== id);
            this.$emit("updatePaquetes", this.products);
        },
        setCategory(e) {
            if (e.value) {
                let category = this.categorias.find((c) => c.id === e.value);
                this.product = {
                    id: category.id,
                    descripcion: category.observacion,
                    peso: category.peso,
                    alto: category.alto,
                    largo: category.largo,
                    ancho: category.ancho,
                    cantidad: 1,
                    precio: category?.precio,
                };
                this.showAddToCategories = false;
                this.addNewToCat = false;
                this.showUpdateCatategory = true;
            } else {
                this.clearProductForm();
            }
        },
        fetchCategories() {
            axios.get("/categorias/get-categories").then((res) => {
                this.categories = res.data;
            });
        },
    },
};
</script>
